var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPaperworkinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 4a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h9v-3a4 4 0 0 1 4-4h3V4Zm-1 12V4a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h8v-2a5 5 0 0 1 5-5h2Z",
  fill: "#252829"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 6h12v1H6V6ZM18 10H6v1h12v-1ZM6 14h12v1H6v-1ZM6 18h6v1H6v-1ZM21.854 17.354a.5.5 0 0 0-.708-.708l-6.5 6.5a.5.5 0 0 0 .708.708l6.5-6.5Z",
  fill: "#252829"
})));
export default SvgPaperworkinline;